// Single source of truth for the brand's WhatsApp number.
// Used by the floating chat button (WhatsAppButton.jsx) and the cart's
// "Request a quote" CTA (CartDrawer.jsx).
//
// Format: international number without "+" or spaces — wa.me requires this form.
export const WHATSAPP_NUMBER = "919873020506"; // +91 98730 20506

export const buildWhatsAppUrl = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
